import { request } from '@/utils/request'

const prefix = '/app'

export function getUpdatesDictionaries (lastUpdateDate) {
  return request({
    url: `${prefix}/updates/dictionaries?` + ((lastUpdateDate && `lastUpdateDate=${lastUpdateDate}`) || ''),
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/rest/dictionary.js